module.exports = __webpack_public_path__ + "static/media/micro-tornillos.683831e2.png";